import React from 'react';
import LabDetails from '../LabDetails/LabDetails';

const Lab = () => {
  return <LabDetails />;
};

export default Lab; 